import { EnumComponentFilter } from "@/admin/filters.tsx";
import { type EnumProps, withEnumBadge } from "@/components/EnumBadge.tsx";
import type { ServiceStatusEnum } from "@warrenio/api-spec/spec.oats.gen";
import { keys } from "remeda";

const serviceStatuses: Record<ServiceStatusEnum, EnumProps> = {
    deleted: { label: "deleted", color: "error" },
    requested: { label: "requested", color: "warning" },
    active: { label: "active", color: "success" },
};

// eslint-disable-next-line react-refresh/only-export-components
export const ServiceStatusBadge = withEnumBadge(serviceStatuses);

export function ServiceStatusFilter() {
    return <EnumComponentFilter values={keys(serviceStatuses)} component={ServiceStatusBadge} />;
}
